import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';

const ModalGateContext = createContext(null);

export function ModalGateProvider({ children }) {
  const blockers = useRef(new Set());
  const [blocked, setBlocked] = useState(false);

  const sync = useCallback(() => {
    setBlocked(blockers.current.size > 0);
  }, []);

  const register = useCallback((id) => {
    blockers.current.add(id);
    sync();
    return () => {
      blockers.current.delete(id);
      sync();
    };
  }, [sync]);

  const isBlocked = useCallback(() => blockers.current.size > 0, []);

  const value = useMemo(
    () => ({ register, blocked, isBlocked }),
    [register, blocked, isBlocked]
  );

  return (
    <ModalGateContext.Provider value={value}>
      {children}
    </ModalGateContext.Provider>
  );
}

export function useModalBlocker(id, active) {
  const gate = useContext(ModalGateContext);
  const register = gate?.register;

  useEffect(() => {
    if (!register || !active || !id) return undefined;
    return register(id);
  }, [register, active, id]);
}

export function useModalGate() {
  return useContext(ModalGateContext);
}
